
import './demo.scss';
import Demo from './demo.tsx';

export default Demo;
